export const MAX_EMBEDDED_ORIGINS = 10;

export type EmbeddedOriginProblem = "invalid" | "duplicate" | "limit";

const LOCAL_HOSTS = ["localhost", "127.0.0.1"];

/**
 * Why an origin cannot join the allowed list, or null when it can. The server
 * holds the same rule and decides; this only answers before the round trip.
 */
export const getEmbeddedOriginProblem = (
  origin: string,
  allowed: string[],
): EmbeddedOriginProblem | null => {
  if (!isExactOrigin(origin)) return "invalid";
  if (allowed.includes(origin)) return "duplicate";
  if (allowed.length >= MAX_EMBEDDED_ORIGINS) return "limit";
  return null;
};

const isExactOrigin = (value: string) => {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }
  if (url.origin !== value || url.hostname.includes("*")) return false;
  return (
    url.protocol === "https:" ||
    (url.protocol === "http:" && LOCAL_HOSTS.includes(url.hostname))
  );
};
